import { patch } from '@core/api/baseApi';

export async function rejectReport(reportId: string): Promise<{ success: boolean }> {
  try {
    const res = (await patch(`/studies/reports/${reportId}/reject`, {})) as {
      message?: string;
      statusCode?: number;
    };

    return { success: !res.message && res.statusCode !== 404 };
  } catch (err) {
    return { success: false };
  }
}
